<li (click)="redirectToAnalytics()">
  <a>
    {{'ANALYTICS' | translate}}
  </a>
</li>
